import { all, fork } from 'redux-saga/effects';

import { deploySaga } from './deploy';

export function* saga() {
  yield all([
    fork(deploySaga),
  ]);
}
